import { render } from "./QuestionnaireRadio.vue?vue&type=template&id=4c97e9a9&scoped=true"
import script from "./QuestionnaireRadio.vue?vue&type=script&lang=js"
export * from "./QuestionnaireRadio.vue?vue&type=script&lang=js"

import "./QuestionnaireRadio.vue?vue&type=style&index=0&id=4c97e9a9&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c97e9a9"]])

export default __exports__